import React from "react";
import api from "../../utils/api";

type BookingReportData = {
    totalBookings: number;
    thisMonthBookings: number;
    todayBookings: number;
};

const BookingReport: React.FC = () => {
    const [bookingData, setBookingData] = React.useState<BookingReportData>({
        totalBookings: 0,
        thisMonthBookings: 0,
        todayBookings: 0,
    });
    const fetchData = async () => {
        const response = await api.get('/api/TicketReport/GetTicketBookingReport');
        if (response.status === 200) {
            const data = response.data;
            setBookingData({
                totalBookings: data.totalPayAmount || 0,
                thisMonthBookings: data.monthlyPayAmount || 0,
                todayBookings: data.todayPayAmount || 0,
            });
        }
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    const cardDetails = [
        {
            label: "Total Bookings",
            value: bookingData.totalBookings,
            icon: <i className="fas fa-rupee-sign fs-2 text-primary"></i>,
            color: "#e3f2fd",
        },
        {
            label: "Monthly Bookings",
            value: bookingData.thisMonthBookings,
            icon: <i className="fas fa-calendar-alt fs-2 text-secondary"></i>,
            color: "#fce4ec",
        },
        {
            label: "Today",
            value: bookingData.todayBookings,
            icon: <i className="fas fa-calendar-day fs-2 text-success"></i>,
            color: "#e8f5e9",
        },
    ];
    return (
        <div className='page-body'>
            <div className="container py-4">
                <h5 className="mb-4">Booking Report</h5>
                <div className="row g-4">
                    {cardDetails.map((card) => (
                        <div className="col-12 col-sm-6 col-md-4" key={card.label}>
                            <div
                                className="card shadow-sm"
                                style={{ minWidth: 220, background: card.color }}
                            >
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <span>{card.icon}</span>
                                        <span className="ms-3 h6 mb-0">{card.label}</span>
                                    </div>
                                    <div className="h4 fw-bold">
                                        ₹ {card.value.toLocaleString()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BookingReport;